const namespace = 'Api';

export const SET_STEP = `${namespace}/SET_STEP`;
export const GO_TO_STEP = `${namespace}/GO_TO_STEP`;
export const RESET_PARAMS = `${namespace}/RESET_PARAMS`;
export const SET_DATA_TO_STEP = `${namespace}/SET_DATA_TO_STEP`;
export const SET_TICKET_ID = `${namespace}/SET_TICKET_ID`;

export const OTHER_CONTENT = `${namespace}/OTHER_CONTENT`;
export const OTHER_CONTENT_SUCCESS = `${namespace}/OTHER_CONTENT_SUCCESS`;
export const OTHER_CONTENT_FAILURE = `${namespace}/OTHER_CONTENT_FAILURE`;

export const MAX_PASSENGERS = 5;

export const ALERT_SET = `${namespace}/ALERT_SET`;

export const MESSAGES_SET = `${namespace}/MESSAGES_SET`;

export const PAYGATE_MESSAGES_SET = `${namespace}/PAYGATE_MESSAGES_SET`;



// WEBPACK FOOTER //
// ./src/containers/App/constants.js